import { useEffect, useState } from "react";
import api, { fmtDT, fmtDate } from "@/lib/api";
import { PageHeader, ProgressBar, StatusBadge, Loading, EmptyState } from "@/components/Shared";
import { ShoppingCart } from "lucide-react";

export default function SupplierOperations() {
  const [ops, setOps] = useState(null);
  useEffect(() => { api.get("/supplier/operations").then((r) => setOps(r.data)).catch(() => setOps([])); }, []);
  if (ops === null) return <Loading />;

  return (
    <div>
      <PageHeader title="Mes opérations" subtitle="Toutes vos opérations d'achat groupé." />
      {ops.length === 0 ? <EmptyState title="Aucune opération" icon={ShoppingCart} /> : (
        <div className="space-y-4">
          {ops.map((op) => (
            <div key={op.id} className="bg-white border border-slate-200 rounded-xl p-5" data-testid={`sup-op-${op.id}`}>
              <div className="flex items-start justify-between gap-3">
                <div>
                  <div className="font-bold text-slate-900">{op.name}</div>
                  <div className="text-xs text-slate-400 mt-0.5">Clôture : {fmtDate(op.close_date)} · {op.participants_count} participants</div>
                </div>
                <StatusBadge status={op.status} />
              </div>
              <div className="mt-4 max-w-lg"><ProgressBar current={op.committed_amount} target={op.objective_amount} /></div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
